module.exports = __webpack_public_path__ + "static/media/Empty_Info@3x.60638c99.png";